'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Section": "Polaris-Modal-Section",
  "titleHidden": "Polaris-Modal-Section--titleHidden"
};

exports.default = styles;
